import {
  ChangeDetectorRef,
  Component,
  Input,
  OnInit,
  SimpleChanges,
  ViewChild,
} from "@angular/core";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { BehaviorSubject, Subscription } from "rxjs";

import { UserService } from "../service/user.service";

import { Log } from "../util/log";
import { DateHelper } from "../util/dateHelper";
import { Output, EventEmitter } from '@angular/core';

import { Overlay } from "@angular/cdk/overlay";
import { MatDialog } from "@angular/material/dialog";
import { ControlUser } from "../model/controlUser";
import { ActivationCode } from "../model/activationCode";
import { ActivationCodes } from "../model/activationCodes";

import { CodeListEditorComponent } from "../code-list-editor/code-list-editor.component";
import { formatDate } from "@angular/common";
import { SendEmailDialogComponent } from "../send-email-dialog/send-email-dialog.component";
import { AppComponent } from "../app.component";
import { EmailDefaultData } from "../model/EmailDefaultData";
import { StringHelper } from "../util/stringHelper";


@Component({
  selector: 'app-code-list',
  templateUrl: './code-list.component.html',
  styleUrls: ['./code-list.component.css']
})
export class CodeListComponent implements OnInit {

  @Input() userOwnerId: number;
  @Input() owner: ControlUser;
  @Input() canUserEdit;

  @Output() activationCodes = new EventEmitter<ActivationCodes>();

  @ViewChild("codelistloader", { static: true }) loader;
  @ViewChild("codelisttable", { static: true }) table;

  language: string;

  dataSource: CodeListSource;
  displayedColumns: string[] = ["code", "description", "date", "email", "emailDate", "sendButton"];

  defaultOwnerEmail: EmailDefaultData;

  getOwnerDefaultEmailSubscription: Subscription;

  constructor(
    public appComponent: AppComponent,
    private userService: UserService,
    private cdRef: ChangeDetectorRef,
    public dialog: MatDialog,
    private overlay: Overlay
  ) { }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['userOwnerId']) {
      setTimeout(() => {
        this.language = this.appComponent.getCurrentLanguage();

        this.loadData();
      });
    }
  }


  ngAfterViewInit() {
    setTimeout(() => {
      this.language = this.appComponent.getCurrentLanguage();

      this.loadData();
    });
  }

  ngOnDestroy(): void {
    if (this.getOwnerDefaultEmailSubscription) {
      this.getOwnerDefaultEmailSubscription.unsubscribe();
    }
  }

  isService(): boolean {
    return this.appComponent.isService();
  }

  loadData() {
    this.loader.showLoading();

    this.dataSource = new CodeListSource(
      this.userOwnerId,
      this.userService,
      this.isService()
    );
    this.table.dataSource = this.dataSource;
    this.dataSource.codeListData.subscribe(
      (data) => {
        Log.debug("Code list Data: " + JSON.stringify(data));
        let activationCodesToEmit: ActivationCodes = new ActivationCodes();
        activationCodesToEmit.codes = data;
        this.activationCodes.emit(activationCodesToEmit);
        setTimeout(() => {
          this.cdRef.detectChanges();
          this.loader.hideLoading();
        });
      },
      (error) => {
        this.loader.hideLoading();
        this.loader.showError();
      }
    );
  }

  formatDate(activatedAt: Date) {
    return formatDate(activatedAt, 'dd/MM/yyyy', 'it-IT');
  }

  getOwnerDefaultEmail(code: ActivationCode) {

    if (!this.defaultOwnerEmail) {
      Log.debug("\n no default email set");

      this.getOwnerDefaultEmailSubscription = this.userService.getOwnerDefaultEmailData(this.owner.id, this.language).subscribe((response) => {

        this.defaultOwnerEmail = response

        this.openEmailDialog(code, this.defaultOwnerEmail);

      }, (err) => {
        console.log(err);
        this.openEmailDialog(code, null);
      });
    } else {
      Log.debug("\n using default email");
      this.openEmailDialog(code, this.defaultOwnerEmail);
    }

  }

  openEmailDialog(code: ActivationCode, defaultEmail: EmailDefaultData) {
    const scrollStrategy = this.overlay.scrollStrategies.reposition();

    const dialogRef = this.dialog.open(SendEmailDialogComponent, {
      width: "1000px",
      data: { code: code, owner: this.owner, defaultEmail: defaultEmail, language: this.language },
      scrollStrategy,
    });

    dialogRef.afterClosed().subscribe((response) => {

      if (response) {
        if (response != "true") {
          this.defaultOwnerEmail = response;
        }
        this.loadData();
      }
    });
  }

  modifyCodeList(): void {
    const scrollStrategy = this.overlay.scrollStrategies.reposition();


    if (!this.dataSource.ActivationCodesArray) {
      this.dataSource.ActivationCodesArray.push(new ActivationCode());
    }

    Log.debug("ActivationCodesArray");
    Log.debug(this.dataSource.ActivationCodesArray);


    const dialogRef = this.dialog.open(CodeListEditorComponent, {
      width: "900px",
      data: { codeListData: this.dataSource.ActivationCodesArray, userOwnerId: this.userOwnerId },
      scrollStrategy,
    });

    dialogRef.afterClosed().subscribe((result) => {

      if (!result) {
      } else if (result) {
        this.loader.showLoading();
        Log.debug("result: ");
        Log.debug(result);

        let activationCodesList: ActivationCodes = new ActivationCodes();

        activationCodesList = result;

        this.table.dataSource.updateData(activationCodesList, this.userOwnerId);
        this.table.renderRows();
        this.loader.hideLoading();
        this.activationCodes.emit(activationCodesList);
      }

      this.dataSource.loadData();
    });
  }
}

export class CodeListSource extends MatTableDataSource<ActivationCode> {
  isLoading = new BehaviorSubject(false);
  codeListData = new BehaviorSubject<ActivationCode[]>([]);

  ActivationCodesArray: ActivationCode[] = [];

  constructor(
    private userOwnerId: number,
    private userService: UserService,
    private isService: boolean) {
    super();
  }

  loadData() {
    this.isLoading.next(true);
    const obs = this.userService.getUserActivationCodes(this.userOwnerId);
    obs.subscribe((data) => {
      Log.debug("Data: ");
      Log.debug(data);

      if (this.isService) {
        for (let i = 0; i < data.length; i++) {
          if (data[i].activationEmail) {
            data[i].activationEmail = StringHelper.censorString(data[i].activationEmail);
          }
        }
      }

      this.ActivationCodesArray = data;
      this.isLoading.next(false);
      this.codeListData.next(data);
    });
  }

  updateData(activationCodeList: ActivationCodes, user: ControlUser) {
    Log.debug("updateData: ");
    Log.debug(activationCodeList);
    Log.debug(activationCodeList.codes[0]);

    this.ActivationCodesArray = activationCodeList.codes;
    this.isLoading.next(false);
    this.codeListData.next(activationCodeList.codes);
  }

  connect(): BehaviorSubject<ActivationCode[]> {
    this.loadData();
    return this.codeListData;
  }

  disconnect() { }
}


